function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "svg_1",
  fillRule: "evenodd",
  fill: "none"
}, React.createElement("g", {
  stroke: "null",
  id: "svg_2",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  stroke: "null",
  id: "svg_3",
  d: "m39.512652,45.614868c0,1.995808 -1.644804,3.631968 -3.683974,3.631968l-31.657356,0c-2.030212,0 -3.683974,-1.629945 -3.683974,-3.631968c0,-10.602511 8.736112,-19.197544 19.512652,-19.197544c10.77654,0 19.512652,8.595033 19.512652,19.197544zm-19.512652,-14.009018c-7.329195,0 -13.365048,5.448028 -14.152059,12.452461l28.304118,0c-0.787011,-7.004432 -6.822864,-12.452461 -14.152059,-12.452461zm0,-7.263935c-6.698931,0 -12.129486,-5.342858 -12.129486,-11.933608c0,-6.59075 5.430556,-11.933608 12.129486,-11.933608c6.698931,0 12.129486,5.342858 12.129486,11.933608c0,6.59075 -5.430556,11.933608 -12.129486,11.933608zm0,-5.188525c3.786352,0 6.855797,-3.019876 6.855797,-6.745083c0,-3.725207 -3.069445,-6.745083 -6.855797,-6.745083c-3.786352,0 -6.855797,3.019876 -6.855797,6.745083c0,3.725207 3.069445,6.745083 6.855797,6.745083z"
})));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 50",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.02cf12fd.svg";
export { ForwardRef as ReactComponent };